import { Button, H4, H6, Icon } from "@alternative/components";
import { IconNames } from "@alternative/icons";
import { Overlay } from "@blueprintjs/core";
import React from "react";

const Dialog = (props) => {
  const { header, isOpen, onClose, children } = props;

  return (
    <Overlay isOpen={isOpen} onClose={onClose}>
      <div className="at-dialog-container" onClick={onClose}>
        <div className="at-dialog" onClick={(e) => e.stopPropagation()}>
          <div className="at-dialog__header">
            <H4>{header}</H4>
          </div>

          <Button className="at-dialog__close-btn" minimal small onClick={onClose}>
            <Icon icon={IconNames.CLOSE} />
          </Button>
          {children}
        </div>
      </div>
    </Overlay>
  );
};

export default Dialog;
